export const FR = {
  message: {
    banner:
      "Suite à un problème technique, l’intégralité des données n’est plus disponible. Nous travaillons à la résolution de cet incident. Veuillez nous excuser pour la gène occasionnée.",
    in: "En",
    loadingText: "Chargement... Veuillez patienter",
    selectCustomer: "Selectionner un client",
    offline: "Site en maintenance",
    refer: "Voir condition d’utilisation",
    error: {
      userNotFound: "Aucun utilisateur trouvé",
      noToken: "Ce lien n'est plus valide",
    },
    alert: {
      mail: "Activer alerte mail",
      sms: "Activer alerte SMS",
      battery: "Alertes batteries",
      disclamer:
        "selon les seuils définis par Akiem Leasing et concernant les locomotives équipés de boitiers Railster",
      sralert: "Alerte signalement",
      toggleAlert:
        "En activant cette option, vous recevrez une notification mail pour chaque signalement émis depuis MyFleetHub",
      quotation: "Alerte devis",
      quotationLabel:
        "En activant cette option, vous recevrez les notifications email dès qu’un nouveau devis sera publié sur MyFleetHub",
    },
    select: "Tout cocher",
    ssoLogin: "Se connecter avec Azure AD",
    rgpd:
      "Akiem s’engage à respecter de manière équitable et transparente la législation sur la protection des données personnelles, " +
      "en particulier le Règlement Général sur la Protection des Données (le « RGPD »).Sur ce portail, nous n'utilisons pas de cookies. " +
      "Ainsi, aucune de vos données personnelles ne sera collectée durant votre session de connexion ni stockée après à la fin de celle-ci. " +
      "Un consentement vous sera expressément demandé dans le cas où vous souhaiteriez utiliser la fonctionnalité «enquête de satisfaction ». ",
    login: {
      welcomeFirst: "bienvenue sur votre",
      welcomeSecond: "espace client",
      id: "Identifiant",
      pw: "Mot de passe",
      restore: "Restaurer mon mot de passe",
      validate: "Valider",
      errorLogin: "Le mot de passe est éronné, merci de recommencer",
      initMsg:
        "Veuillez renseigner votre mot de passe pour finaliser la creation de votre compte",
    },
    aside: {
      home: "Accueil",
      notice: "Notice d’Utilisation",
      logout: "Déconnexion",
      config: "Configuration",
      account: "Mon compte",
      profil: "Infos profils",
      alert: "Mes alertes",
      parc: "Mon parc",
      planning: "Mon planning",
      detail: "Détail de ma flotte",
      geo: "Géolocaliser mon materiel",
      board: "Tableau de bord",
      km: "Kilomètres",
      hm: "Heures Moteur",
      battery: "Info batterie",
      mint: "My MINT",
      magic: "Maintenance Interventions",
      history: "Historique",
      infoloc: "Info locomotive",
      fleetcontrol: "Fleet control",
      unleased: "Flotte non louée",
      doc: "Mes documents",
      edl: "Etats des lieux / Certificats",
      certificat: "Certificats",
      jobplan: "Maintenance à venir",
      krefeldplan: "Krefeld plan",
      batterytable: "Derniers relevés batterie",
      geofencing: "Geofencing",
      disponibility: "Disponibilité contractuelle",
      admin: "Menu interne",
      locoInternal: "Créer un ticket hotline",
      adminloco: "Administrer les locomotives",
      userlist: "Liste des utilisateurs",
    },
    superuser: {
      profile: "Profil",
      action: "Action",
      updateprofile: "Modification de profil",
      administrator: "Administrateur",
      management: "Management",
      operational: "Operationnel",
      commercial: "Commercial",
      delmessage1:
        "Vous êtes sur le point de demander la suppression de compte",
      delmessage2:
        "Un message informera le département informatique d’Akiem qui procèdera à la suppression du compte.",
      delmessage3:
        "n’aura plus accès au portail client My Fleet hub. Si le user souhaite re créer un compte ultérieurement, il/elle devra contacter son Service Contract manager. Voulez-vous continuer? ",
      legendmgt:
        "le profil management peut consulter tous les modules du portail. Il peut valider les extra work.",
      legendcom:
        "Le profil commercial peut consulter tous les modules du portail. Il ne peut pas valider les extra work.",
      legendoper:
        "Le profil opérationnel peut consulter les modules du portail excepté le module « mes extra work »",
    },
    geofencing: {
      select: "Veuillez sélectionner une valeur",
      entry: "Date et heure d'entrée",
      exit: "Date et heure de sortie",
      dbenergy: "Avez-vous pensé à faire votre déclaration DB Energy?",
    },
    header: {
      language: "Langues",
    },
    home: {
      team: "Mon équipe dédiée Akiem",
      name: "Nom",
      firstname: "Prénom",
      function: "Fonction",
      fixphone: "Tél fixe",
      mobilephone: "Tél protable",
      mail: "E-mail",
      locoInfo: "Créer une demande de service express",
    },
    page: {
      assignment: "Affectations",
      customer: "Portail",
      portal: "Client",
      availableLoco: "Maintenue(s) par AKIEM",
      loconumber: "Numéro de locomotive",
      status: "Statut opérationnel",
      available: "Disponible",
      maintenance: "En maintenance",
      connexionDate: "Date de la dernière connexion",
      findLocation: "Trouver l'emplacement des matériels roulants",
      contractNumber: "Numéro de contrat",
      serial: "Série",
      contractStatus: "Statut contractuel",
      startDate: "Date début",
      endDate: "Date Fin",
      delta:
        "En sélectionnant une plage de dates, vous obtiendrez un tracé de votre parcours",
      locate: "Localisation",
      titular: "Titulaire",
      reserve: "Reserve",
      spot: "Spot",
      performance: "Performance",
      cumulTitle: "Kilomètres cumulés par locomotive",
      cumul: "Km cumulés",
      distance: "Distance",
      moyMonth: "Moyenne des KM parcourus / Mois",
      filterMsg:
        "En selectionnant une seule locomotive, vous obtenez le tracé de votre parcours",
      availableNotice: '"Ne comprend pas les signalements en compte"',
      doctype: "Type de document",
      eventdate: "Date du document",
      filetype: "Type de fichier",
      contractType: "Type de contrat",
    },
    opinionGlobal: {
      opinion: "Mon avis sur le portail",
      opinionFirst: "Mon avis",
      opinionSecond: "Sur le portail",
      opinionRedirectionOne: "Vous allez être redirigé vers une page externe,",
      opinionRedirectionTwo: "souhaitez vous poursuivre ?",
      opinionClic:
        "En cliquant sur ce lien, vous acceptez de quitter ce portail pour accéder à la plateforme Eval N Go permettant la réalisation de cette enquête de satisfaction " +
        "et consentez ainsi au traitement de vos données personnelles.",
      opinionPersonelData:
        "Les données personnelles nécessaires et collectées sont les suivantes :",
      opinionMail: "Adresses mail",
      opinionName: "Nom",
      opinionDataTransmission:
        "Ces données ne sont transmises qu’aux seules personnes habilitées à Akiem," +
        "lesquelles sont soumises au devoir de confidentialité, et seront conservées pendant 1 an.",
      opinionStock:
        "Elles sont hébergées en France et ne seront pas transmises hors de l’UE.",
      opinionRules:
        "Conformément à la loi en vigueur, vous disposez de droits pour maîtriser vos données personnelles (droits d'accès, de rectification, etc) " +
        "que vous pouvez exercer en vous adressant par courriel à dpo@akiem.com",
      opinionHelp:
        "Cette démarche nous aide à davantage progresser dans la manière de vous accompagner et à mieux comprendre vos besoins, " +
        "votre contribution serait une aide précieuse.",
      opinionYes: "Oui",
      opinionNo: "Non",
    },
    pageKm: {
      trackingKm: "Suivi des kilomètres",
      tableKm: "Tableau des kilomètres",
      status: "Statut Contractuel",
      serial: "Numéro de série",
      contract: "Contrats",
      contractnum: "Numéro de contrat",
      total: "Total distance",
      loco: "Locomotives",
      date: "Dates",
      since: "Depuis le",
      kmNotice: '"Kilomètres relevés selon les données Railster transmises" ',
    },
    pageHm: {
      title: "Heures Moteur",
      lastcheck: "Dernières données relevées",
      cumulativeHm: "Heures moteurs cumulés",
      hm: "Heures moteurs",
      total: "Total consommé des heures moteurs",
      portalReal: "Relevé réalisé depuis le portail",
      maintenanceReal: "Relevé réalisé lors d’une maintenance",
      detailHm: "Détail des heures moteur consommées",
    },
    maintenance: {
      workshops: "Ateliers de maintenance",
    },
    pageAlert: {
      alert: "Mes alertes",
      inout: "ENTREE ET SORTIE LOCOMOTIVE",
      serial: "Sur une série",
      contract: "Sur un contrat",
      loco: "Sur les locs de mon parc",
      mail: "Activer alertes mail",
      sms: "Activer alertes sms",
      battery: "ALERTES BATTERIE",
    },
    passwordResetPage: {
      first: "Veuillez renseigner votre mot de passe",
      confirm: "mot de passe confirmation",
      pwRuleOne: "mot de passe requis",
      pwRuleTwo: "8 caractères minimum",
      pwRuleThree:
        "Le mot de passe doit contenir au moins une lettre minuscule, un chiffre, un caractère spécial et une lettre majuscule",
      pwConfirmOne: "la confirmation du mot de passe est requise",
      pwConfirmTwo: "La confirmation du mot de passe ne correspond pas",
      pwSuccess: "Mot de passe reinitialisé avec success",
      validate: "Valider",
    },
    pageNotice: {
      second:
        "Les données, informations et/ou documents figurant sur ce Portail et/ou disponibles par ce Portail sont publiés seulement" +
        " à titre indicatif et informatif et n’ont aucune valeur contractuelle.",
      third:
        "Ces données, informations et/ou documents peuvent contenir des inexactitudes et des erreurs. Ils sont susceptibles d’être" +
        " modifiés par Akiem à tout moment, et peuvent faire l’objet de mises à jour. Il est fortement recommandé de vérifier l’exactitude" +
        " et la pertinence données, des informations et/ou documents mis à disposition sur ce Portail.",
      fourty:
        "L’utilisation des données, informations et/ou documents disponibles sur ce Portail se fait sous l’entière et seule responsabilité" +
        " de l’Utilisateur du Portail, qui assume la totalité des conséquences pouvant en découler, sans que la responsabilité d’Akiem puisse être" +
        " recherchée à ce titre, et sans recours contre Akiem.",
      fifty:
        "Akiem ne pourra en aucun cas être tenu responsable de tout dommage de quelque nature qu’il soit résultant d’une interprétation ou de " +
        "l’utilisation des informations et/ou documents disponibles sur ce Portail.",
      sixty:
        "Le Portail est normalement accessible 24 heures sur 24 et 7 jours sur 7, sauf en cas de force majeure ou d’un événement hors du contrôle " +
        "de Akiem et sous réserve des éventuelles pannes et interventions de maintenance nécessaires au bon fonctionnement du Portail, aux Utilisateurs " +
        "disposant d’un accès à internet. Akiem se réserve la possibilité d’interrompre, à tout moment sans préavis, ou de suspendre momentanément ou de " +
        "modifier l’accès à tout ou partie du Portail, afin d’en assurer la maintenance, ou pour toute autre raison, sans que l’interruption n’ouvre droit à " +
        "aucune obligation ni indemnisation.",
      seventy:
        "Akiem s’engage à respecter de manière équitable et transparente la législation sur la protection des données personnelles, en particulier " +
        "le Règlement Général sur la Protection des Données (le « RGPD »). Akiem a mis en place les mesures techniques et organisationnelles pour veiller à " +
        "ce que les données de l’Utilisateur soient protégées contre les accès non-autorisés ainsi que tout autre risque de sécurité et de vulnérabilité informatique.",
      eighty:
        "Sur ce Portail, nous n'utilisons pas de cookies. Ainsi, aucune de vos données personnelles ne sera collectée durant votre session de connexion" +
        " ni stockée après à la fin de celle-ci. Un consentement vous sera expressément demandé dans le cas où vous souhaiteriez utiliser la fonctionnalité « enquête de satisfaction ».",
    },
    magic: {
      workorderTitle: "Titre de l'intervention",
      workorder: "Intervention",
      startDate: "Date de debut",
      endDate: "Date de fin",
      meter: "Kilometrage",
      hours: "Heures moteur",
      technicDoc: "Documentation technique",
      restriction: "Restriction/Reason",
      date: "Date",
      asset: "Materiel roulant",
      km: "KM",
      leftD1: "D1 gauche",
      leftD2: "D2 gauche",
      leftD3: "D3 gauche",
      leftD4: "D4 gauche",
      rightD1: "D1 droit",
      rightD2: "D2 droit",
      rightD3: "D3 droit",
      rightD4: "D4 droit",
      action: "Action",
      description: "Recapitulatif - Lieu",
      desc: "Description",
      addFile: "Ajouter une pièce jointe",
      reportBy: "Signalé par",
      id: "ID",
      status: "Statut",
      sr: "Signalement",
      srAttechement: "Signalements rattachés",
      attachements: "Pièces jointes",
      mileage: "Relevés données",
      createAlert: "Créer un signalement",
      title: "Titre",
      location: "Lieu",
      priority: "Priorité",
      addKm: "Communiquer un relevé",
      newKm: "Nouvelle valeur",
      lastreading: "Valeur actuelle",
      scheduleDate: "Dates de planification",
      metername: "Type de relevé",
      executeDate: "Dates d'execution",
      error: "Echec de l'operation",
      success: "Operation reussie",
      attachment: "ajouter une pièce jointe",
      unit: "Unité",
      source: "Source",
      jobplan: "Job plan type",
      type: "Type",
      reportedDate: "Date de creation",
      details: "Détails",
      hotline: "Ticket de hotline",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Valider",
      cancel: "Annuler",
    },
    search: "Recherche",
    history: {
      pm: "Historique des interventions préventives",
      cm: "Historique des interventions correctives",
    },
    infoloc: {
      infoOp: "Informations opérationnelles",
      infoTech: "Informations techniques",
      cert: "Homologations",
      openSr: "Signalements ouverts",
      sr: "Signalements",
      dateAndKm: "Dates et kilometrages",
      pmPlan: "Plan de maintenance prévisionnelle",
      locomotive: "Locomotive",
      actWorkorder: "Intervention en cours",
      outPrevDate: "Date prévisionnelle de sortie",
      nextWorkDate: "Prochaine maintenance",
      wheelset: "Information essieu",
      unitToGo: "Kilomètres restants",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "Historique des kilometres",
      hhm: "Historique des hm",
      fuellevel: "Niveau fioul",
      parking: "Hors tension",
      traction: "En mouvement - traction",
      vehicle: "En mouvement - traction",
      poweron: "Sous tension sans mouvement",
      standby: "Moteur diesel allumé sans mouvement",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Annulé",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "Nouveau",
      sinprogress: "En cours",
      closed: "Clos",
    },
    woStatus: {
      WSCH: "En attente de planification",
      WAPPR: "En attente de planification",
      WPCOND: "En attente de planification",
      CLOSE: "Terminé",
      COMP: "Terminé",
      INPRG: "Intervention en cours",
      REVIEWED: "Terminé/ en attente de libération ECM3",
      WCOE: "En attente prix ou matériel",
      WMATL: "En attente prix ou matériel",
      APPR: "Validé",
      CA: "Annulé",
      NOTPERF: "Non réalisé",
      CAN: "Annulé",
    },
    doc: {
      certificat: {
        delivry: "CERTIFICAT DE LIVRAISON",
        redelivry: "CERTIFICAT DE RESTITUTION",
        genralInfo: "INFORMATIONS GENERALES",
        technicalInfo: "DONNEES TECHNIQUES",
        signature:"SIGNATURES",
        asOf:"En date du",
        andAccording: "et conformément aux dispositions prévues",
        contractRes: "au Contrat /reservation* ",
        representBy:"la société  Akiem SAS (ci-après le Bailleur), représentée par Sebastian Rodriguez",
        delivryTo: "remet à la société ",
        society:"la société",
        lessee: " (ci-après le Locataire) ",
        delivryToAkm:"remet à la société Akiem représentée par Sebastian Rodriguez",
        locomotive: "la locomotive",
        locoType: "type",
        delivryAt: "livrée sur le site de",
        redelivryAt:"sur le site de :",
        restDerog:"Restrictions/ dérogations",
        comment:"Commentaires",
        edl:"Etat des lieux joint en annexe [oui/non]",
        remark:"Remarque",
        rem1:"Sous réserve des dispositions contractuelles, cette locomotive doit être assurée au plus tard à partir de la date de livraison indiquée sur le certificat.",
        rem2:"*La garde de la locomotive est transférée au locataire à la date de livraison citée dans le présent certificat",
        kmCompteur: "Km compteur",
        hmMoteur: "Heures moteurs",
        wheelset: "Essieux",
        recentData: "données les plus récentes*",
        subjectTo: "*Sous réserve de l’état des lieux le cas échéant. ",
        lastRecord: "Dernier relevés le",
        date:"Date",
        defaultMes:"A défaut de réception de réserve sous 48 heures, ce certificat sera considéré comme définitif.",
        addBill:"Des frais supplémentaires pour la remise en état de la locomotive seront éventuellement refacturés au Locataire.",
        yes: "OUI",
        no: "NON",
        reserv: "Emmètre une réserve",
        reject: "Réserves émises"

      },
      type: "Type de document",
      edl: {
        delivry: "Etat des lieux de livraison ",
        redelivry: "Etat des lieux de restitution ",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Etat des lieux de livraison",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Etat des lieux de restitution",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Certificats de livraison",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Certificat de restitution",
      },
    ],
    poi: {
      workshop: "Entrée/sortie d’atelier",
      entry: "Entrée estimée le",
      exit: "Sortie estimée le",
      at: "à",
    },
    extrawork: {
      title: "Mes Extra-works",
      newquote: "Nouveaux devis",
      quotewaiting: "En attente de validation",
      messageconfirm: "Merci de renseigner votre numéro de commande",
      confirm: "Confirmer",
      reject: "Contester",
      cancel: "Annuler",
      whyreject: "Pour quelle raison souhaitez-vous rejeter le devis",
      rejectcomment: "merci de renseigner un commentaire",
      quotenum: "N° devis",
      quotetitle: "Titre du devis",
      quoteprice: "Prix HT",
      quotestatus: "Statut du devis",
      realisationdate: "Réalisation effective",
      customerpo: "Po client",
      tovalidate: "En attente de validation",
      validated: "Acceptés",
      rejected: "Rejetés",
      quoterejected: "Refusé",
      quotesrejected: "Devis rejetés",
      comment: "Commentaire",
      unitprice: "Prix unitaire",
      service: "Services",
      quantity: "Quantité",
      totalprice: "Prix total",
      quotetotalprice: "Coût total du devis",
      statusbilled: "facturé",
      statusvalidated: "validé",
    },
    dispoc: {
      past: "Voir les affectations passées",
      widgetText: "Voir ma disponibilité contractuelle",
      taux: "Taux",
      recapLoc: "Disponibilité",
      ticmp: "Taux d'immobilisation cause préventif",
      timcc: "Taux d'immobilisation cause correctif",
      ticc: "Taux d'immobilisation client",
      locDisp: "Disponibles",
      locTot: "Totales",
      week: "Semaine",
      ldispo: "Disponible",
      ldmd: "Disponible en mode degradée",
      lmp: "Maintenance preventice",
      lmc: "Maintenance corrective",
      lach: "Acheminement",
      lmcc: "Maintenance corrective client",
      indisponibilite: "Indisponibilité",
      dispGen: "Disponibilité générale",
      causeCorrective: "cause corrective",
      causePreventive: "cause préventive",
      causeClient: "client",
    },
    restriction: {
      title: "Restriction active en",
      partial: "Restriction partielle",
      total: "Restriciton totale",
      dates: "Du {start} au {end}",
    },
  },
  country: {
    AT: "Autriche",
    BE: "Belgique",
    CH: "Suisse",
    CZ: "République tchèque",
    DE: "Allemagne",
    DK: "Danemark",
    FR: "France",
    HR: "Croatie",
    HU: "Hongrie",
    IT: "Italie",
    LU: "Luxembourg",
    MA: "Maroc",
    NL: "Pays-Bas",
    PL: "Pologne",
    RO: "Roumanie",
    SE: "Suède",
    SK: "Slovaquie",
    SI: "Slovénie",
    RS: "Serbie",
  },
};

export default FR;
